import formulateUserProfile from '~/mixins/formulateUserProfile';

export default {
	mixins: [formulateUserProfile],
	data() {
		return {
			autocompleted: false,
			autocompletedFields: {},
		};
	},
	methods: {
		getAutocompletedFields(fields, needUpdate) {
			return new Promise((resolve) => {
				this.getFormulateUser(needUpdate).then((profile) => {
					if (this.$auth.loggedIn && profile) {
						fields.forEach((field) => {
							if (field.name in profile) {
								if (profile[field.name] !== '') {
									// eslint-disable-next-line no-param-reassign
									this.autocompletedFields[field.name] = profile[field.name];
								}
							} else if (field.name in this.$auth.user) {
								this.autocompletedFields[field.name] = this.$auth.user[field.name];
							}
						});

						if (!this.autocompletedFields.email) {
							// eslint-disable-next-line no-param-reassign
							this.autocompletedFields.email = this.$auth.user.email;
						}
						resolve(this.autocompletedFields);
					}

					this.autocompleted = true;
				});
			});
		},
	},
};
